import { render, staticRenderFns } from "./ProductPlanDetailsTitleAndPrice.vue?vue&type=template&id=9a18505e&scoped=true&"
import script from "./ProductPlanDetailsTitleAndPrice.vue?vue&type=script&lang=js&"
export * from "./ProductPlanDetailsTitleAndPrice.vue?vue&type=script&lang=js&"
import style0 from "./ProductPlanDetailsTitleAndPrice.vue?vue&type=style&index=0&id=9a18505e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9a18505e",
  null
  
)

export default component.exports